import React from "react";
import {
    RmLookupAutoMap,
} from "../../graphql/generated";

export const LookupAutoMapSelector: React.FC<{
    value: RmLookupAutoMap;
    disabled?: boolean;
    onChange: (
        value: RmLookupAutoMap,
    ) => void;
}> = ({ value, disabled, onChange }) => {
    return (

        <select value={value} disabled={disabled} onChange={(e) => onChange(e.target.value as RmLookupAutoMap)}>
            <option value={RmLookupAutoMap.None}>None</option>
            <option value={RmLookupAutoMap.Exact}>Exact</option>
            <option value={RmLookupAutoMap.SplitPascalCase}>Split PascalCase</option>
        </select>

    );
};
